import { render } from "./ThankYouPageComponent.vue?vue&type=template&id=e52bb75e"
import script from "./ThankYouPageComponent.vue?vue&type=script&lang=js"
export * from "./ThankYouPageComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__